import script from "./SideBarLinkItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBarLinkItem.vue?vue&type=script&setup=true&lang=ts"

import "./SideBarLinkItem.vue?vue&type=style&index=0&id=1aad7694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aad7694"]])

export default __exports__